import * as React from 'react'
import App from './App'
import { Provider } from 'react-redux'

const Root = (props: { store: any }) => {
    const { store } = props
    return (
        <div>
          <Provider store={store}>
            <App />
          </Provider>
        </div>
    )
}

export default Root
